(() => {
  const root = document.getElementById('ftp-email-signup');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  const teaser = root.querySelector('.ftp-signup-teaser');
  if (!dialog || !teaser || typeof dialog.showModal !== 'function') return;
  const key = 'ftp-email-welcome-v1';
  const get = (storage, name) => { try { return window[storage].getItem(name); } catch { return null; } };
  const set = (storage, name, value) => { try { window[storage].setItem(name, value); } catch {} };
  const sessionKey = root.dataset.previewMode === 'true' ? 'ftp_email_popup_editor_seen_v2' : 'ftp_email_popup_seen_v2';
  const hasShown = () => {
    try {
      if (document.cookie.split(';').some((part) => part.trim() === sessionKey + '=1')) return true;
    } catch {}
    return get('sessionStorage', sessionKey) === '1';
  };
  const markShown = () => {
    set('sessionStorage', sessionKey, '1');
    try { document.cookie = sessionKey + '=1; Path=/; SameSite=Lax'; } catch {}
  };
  let trigger;
  let dismissed = false;
  const success = Boolean(root.querySelector('[data-signup-success]'));
  const open = () => {
    if (dialog.open) return;
    trigger = document.activeElement;
    teaser.hidden = true;
    dialog.showModal();
    markShown();
    if (!success) root.querySelector('input[type="email"]')?.focus();
  };
  const dismiss = () => {
    dismissed = true;
    teaser.hidden = true;
    markShown();
    if (dialog.open) dialog.close();
    if (trigger instanceof HTMLElement && trigger.isConnected) trigger.focus();
  };
  root.querySelector('[data-signup-open]').addEventListener('click', open);
  root.querySelector('[data-signup-close]').addEventListener('click', dismiss);
  root.querySelector('[data-teaser-close]').addEventListener('click', dismiss);
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  if (success) {
    set('localStorage', key + '-subscribed', '1');
    const footerSuccess = document.querySelector('[data-ftp-footer-success]');
    if (!footerSuccess || window.location.hash === '#FtpEmailSignupForm') open();
    return;
  }
  if (root.querySelector('[data-signup-errors]')) { open(); return; }
  if (root.dataset.previewMode === 'true') { if (!hasShown()) open(); return; }
  if (root.dataset.knownCustomer === 'true') return;
  if (get('localStorage', key + '-subscribed')) return;
  if (hasShown()) return;
  const hasVisibleModal = () => Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => {
    if (element === dialog || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    if (typeof element.checkVisibility === 'function') return element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
    const style = window.getComputedStyle(element);
    return element.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none' && style.opacity !== '0';
  });
  const showOffer = () => {
    if (!root.isConnected || dismissed) return;
    if (document.hidden || hasVisibleModal()) {
      window.setTimeout(showOffer, 5000);
      return;
    }
    if (!hasShown()) open();
  };
  window.setTimeout(showOffer, Number(root.dataset.delay) || 25000);
})();
